var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSelectcheck = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.40805 5.85624C4.55078 5.99898 4.7822 5.99897 4.92493 5.85623L10.3232 0.457395C10.5835 0.19704 11.0056 0.196954 11.266 0.457202C11.5266 0.717571 11.5266 1.13988 11.2662 1.40034L5.0453 7.62121C4.83609 7.83042 4.4969 7.83042 4.28768 7.62121L0.895162 4.22869C0.634852 3.96838 0.634851 3.54633 0.895162 3.28602C1.15547 3.02571 1.57752 3.02571 1.83783 3.28602L4.40805 5.85624Z",
    fill: "#CD384A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSelectcheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/selectcheck.347379f8.svg";
export { ForwardRef as ReactComponent };